import { decodeUtf8Mojibake } from "../../../utils/filenameEncoding";

const displayName = (value) => decodeUtf8Mojibake(value);

export const mapTextItem = (t, i) => ({
  id: `text-${t.upload_id || t.id || i}`,
  pythonFileUuid: t.upload_id,
  name:
    displayName(t.name) ||
    displayName(t.file_name) ||
    (t.text_content ? t.text_content.slice(0, 60) : `Text ${i + 1}`),
  type: "file",
  parentId: null,
  size: t.size || t.characters || 0,
  updatedAt: t.updated_timestamp || t.updatedAt || t.created_timestamp,
  uploadedBy: t.submitted_by || t.uploaded_by || "Me",
  isPersonalSpace: false,
  isUnorganized: false,
  approvalStatus: t.approval_status || "approved",
  fileStatus: t.upload_status || "1",
  createdAt: t.created_timestamp || t.createdAt,
  fileType: "text",
  fileExtension: "txt",
  ownerType: "admin",
  mode: t.mode || "global",
});

export const mapQaItem = (q, i) => ({
  id: `qa-${q.upload_id || q.id || i}`,
  pythonFileUuid: q.upload_id,
  name: q.question
    ? `${q.question.slice(0, 80)}${q.question.length > 80 ? "..." : ""}`
    : `Q&A ${i + 1}`,
  type: "file",
  parentId: null,
  size: (q.question?.length || 0) + (q.answer?.length || 0),
  updatedAt: q.updated_timestamp || q.updatedAt || q.created_timestamp,
  uploadedBy: q.submitted_by || q.uploaded_by || "Me",
  isPersonalSpace: false,
  isUnorganized: false,
  approvalStatus: q.upload_status === "1" ? "approved" : "pending",
  fileStatus: q.upload_status || "1",
  createdAt: q.created_timestamp || q.createdAt,
  fileType: "qa",
  fileExtension: "qa",
  ownerType: "admin",
  mode: q.mode || "global",
});

export const mapTrainedItem = (item) => ({
  id: String(item.id),
  name: displayName(item.name),
  type: item.itemType === "folder" ? "folder" : "file",
  parentId: item.parentId ? String(item.parentId) : null,
  size: item.size,
  updatedAt: item.updatedAt,
  uploadedBy: item.uploadedBy,
  uploaded_file_id: item.uploaded_file_id,
  pythonFileUuid: item.pythonFileUuid,
  document_id: item.document_id ?? null,
  mode: item.mode,
  ownerType: item.ownerType || "user",
  isUnorganized: false,
  approvalStatus: item.status || "approved",
  fileStatus: item.fileStatus || "1",
  createdAt: item.createdAt || item.updatedAt,
  fileType: item.type,
  fileExtension: item.file_extension,
});

export const mapUnorganizedItem = (doc) => ({
  id: `unorganized-${doc.id || doc.file_id}`,
  name: displayName(doc.name) || displayName(doc.original_filename),
  type: "file",
  parentId: doc.folder_id ? String(doc.folder_id) : null,
  size: doc.size || doc.file_size,
  updatedAt: doc.updatedAt || doc.created_timestamp,
  uploadedBy: doc.uploaded_by || "Me",
  uploaded_file_id: doc.id || doc.file_id,
  pythonFileUuid: doc.python_file_uuid,
  document_id: doc.document_id ?? null,
  mode: doc.mode || doc.upload_mode,
  ownerType:
    doc.mode === "global" ||
    doc.mode === "group" ||
    doc.upload_mode === "global" ||
    doc.upload_mode === "group"
      ? "admin"
      : "user",
  isUnorganized: true,
  approvalStatus: doc.approval_status || "approved",
  fileStatus: doc.file_status || "1",
  createdAt: doc.createdAt,
  fileType: doc.type,
  fileExtension: doc.file_extension,
});

export const mapPersonalSpaceFolder = (folder) => ({
  id: `ps-folder-${folder.user_files_id}`,
  name: displayName(folder.name) || displayName(folder.user_files_name),
  type: "folder",
  parentId: folder.parent_id ? `ps-folder-${folder.parent_id}` : null,
  size: 0,
  updatedAt: folder.updated_timestamp || folder.created_timestamp,
  uploadedBy: "Me",
  isPersonalSpace: true,
  isUnorganized: false,
  approvalStatus: "approved",
  fileStatus: folder.user_files_status || "1",
  createdAt: folder.created_timestamp,
  fileType: "folder",
  fileExtension: "folder",
  originalId: folder.user_files_id,
});

export const mapPersonalSpaceFile = (doc) => ({
  id: `ps-file-${doc.user_files_id}`,
  name: displayName(doc.name) || displayName(doc.user_files_name),
  type: "file",
  parentId: doc.parent_id ? `ps-folder-${doc.parent_id}` : null,
  size: doc.file_size,
  updatedAt: doc.updated_timestamp || doc.created_timestamp,
  uploadedBy: "Me",
  isPersonalSpace: true,
  isUnorganized: false,
  approvalStatus: "approved",
  fileStatus: doc.user_files_status || "1",
  createdAt: doc.created_timestamp,
  fileType: doc.file_type || doc.file_extension,
  fileExtension: doc.file_extension,
  originalId: doc.user_files_id,
  document_id: doc.document_id ?? null,
});
